/**
 * PAGE-LOADER
 * Container of page with loading status
 */
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { STATUS_LOADING } from "@/redux/_status.types"
import { useEffect, useState } from "react"

interface OwnProps {
  children?: any
  minHeight?: number
  forceLoading?: boolean
  isFlex?: boolean
  status: string | null //Status
  className?: string //Class for the container
}

function PageLoader(props: OwnProps) {
  const [isLoading, setIsLoading] = useState(props.forceLoading ? true : false)

  useEffect(() => {
    if (props.forceLoading) {
      setTimeout(() => {
        setIsLoading(false)
      }, 150)
    }
  }, [])

  return (
    <div
      className={`flex flex-dcol page-loader ${props.className ? props.className : ""}`}
      style={{
        minHeight: props.minHeight ? props.minHeight + "px" : "80px"
      }}>
      {props.status === STATUS_LOADING || isLoading ? (
        <div className="load-container">
          <FontAwesomeIcon icon={faCircleNotch} spin />
        </div>
      ) : (
        <div className={props.isFlex ? "flex" : ""}>{props.children}</div>
      )}
    </div>
  )
}

export default PageLoader
